import {
  filterCriteria as couponFilterCriteria,
  searchColumnHeaders as couponColumnHeaders,
} from "@/views/Coupon/inputs";

import {
  filterCriteria as discountRuleFilterCriteria,
  searchColumnHeaders as discountRuleColumnHeaders,
} from "@/views/DiscountRule/inputs";

import * as Entities from "@/resources/Entities";

export const inputs = [
  {
    id: "coupon",
    placeholder: "Select Coupon",
    type: "search",
    title: "Coupon",
    label: "name",
    class: "grid-row-two-column",
    entity: Entities.COUPON,
    columnHeaders: couponColumnHeaders,
    filterCriteria: couponFilterCriteria,
    isClearable: true,
    fieldsToDisplay: [
      { label: "Name", id: "name" },
      { label: "ID", id: "_id" },
    ],
    filter: {
      isDeleted: false,
      isArchived: false,
      isActive: true,
    },
  },
];

export const discountRuleInputs = [
  {
    id: "coupon",
    placeholder: "Select Coupon Rule",
    type: "search",
    title: "Coupon Rule",
    label: "name",
    class: "grid-row-two-column",
    entity: Entities.DISCOUNTRULE,
    columnHeaders: discountRuleColumnHeaders,
    filterCriteria: discountRuleFilterCriteria,
    isClearable: true,
    fieldsToDisplay: [
      { label: "Name", id: "name" },
      { label: "ID", id: "_id" },
    ],
    filter: {
      isDeleted: false,
      isActive: true,
      discountType: "coupon",
    },
  },
];
